import type { BasicSuccessResponse, HTTPFunctions } from './types';
import type { ErrorData } from 'ErrorBoundary';

const error = ({ post }: HTTPFunctions) => ({
  saveError: (data: ErrorData) => post<BasicSuccessResponse>('/errors/frontend/', data),
});

export default error;
